"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.useItinerarySegmentMinimalColumnWidth = exports.ItineraryProvider = exports.ItineraryContext = void 0;
var React = _interopRequireWildcard(require("react"));
const ItineraryContext = exports.ItineraryContext = /*#__PURE__*/React.createContext({
  setItinerarySegmentMinimalColumnWidth: () => {},
  itinerarySegmentMinimalColumnWidth: 0
});
const ItineraryProvider = ({
  children
}) => {
  const [minWidth, setMinWidth] = React.useState(70);
  const setItinerarySegmentMinimalColumnWidth = React.useCallback(val => {
    setMinWidth(prev => Math.max(prev, val));
  }, [setMinWidth]);
  const value = React.useMemo(() => ({
    setItinerarySegmentMinimalColumnWidth,
    itinerarySegmentMinimalColumnWidth: minWidth
  }), [setItinerarySegmentMinimalColumnWidth, minWidth]);
  return /*#__PURE__*/React.createElement(ItineraryContext.Provider, {
    value: value
  }, children);
};
exports.ItineraryProvider = ItineraryProvider;
const useItinerarySegmentMinimalColumnWidth = () => React.useContext(ItineraryContext);
exports.useItinerarySegmentMinimalColumnWidth = useItinerarySegmentMinimalColumnWidth;